import classNames from "classnames"
import { Checkbox } from "../../../common"
import Avatar from "./Avatar"
import {
  getCurrentRole,
  getFitScore,
  getFullName,
  getInitials,
  getLocation,
  getPictureUrl,
  getProfileId,
} from "../utils"

/**
 * One result row in the sourcing list.
 *
 * Visually mirrors the existing CVItem row pattern (white card, name on the left,
 * date/status on the right) so the platform feels consistent — but with the
 * sourcing-specific bits (avatar initials, fit-score bar, location).
 */
const CandidateRow = ({ profile, selected, onToggle, onOpen }) => {
  const id = getProfileId(profile)
  const fullName = getFullName(profile)
  const initials = getInitials(profile)
  const pictureUrl = getPictureUrl(profile)
  const { title, company } = getCurrentRole(profile)
  const location = getLocation(profile)
  const fit = getFitScore(profile)

  return (
    <div
      className={classNames("sourcing-row", { "sourcing-row--selected": selected })}
      onClick={(e) => {
        // Click on the row body opens the dossier; the checkbox handles its own click.
        if (e.target.closest(".sourcing-row__cbx")) return
        onOpen(profile)
      }}
    >
      <div
        className="sourcing-row__cbx"
        onClick={(e) => e.stopPropagation()}
      >
        <Checkbox
          variant="secondary"
          value={selected}
          onChange={(e) => onToggle(id, e.target.checked)}
        />
      </div>

      <Avatar
        url={pictureUrl}
        initials={initials}
        size="small"
        className="sourcing-row__avatar"
      />

      <div className="sourcing-row__info">
        <p className="sourcing-row__name">{fullName}</p>
        {title && (
          <p className="sourcing-row__role">
            {title}
            {company && (
              <>
                {" at "}
                <span className="sourcing-row__company">{company}</span>
              </>
            )}
          </p>
        )}
      </div>

      {fit !== null && (
        <div className="sourcing-row__fit" title={`Fit ${fit}`}>
          <div
            className="sourcing-row__fit-bar"
            style={{ "--sourcing-fit": `${fit}%` }}
          />
          <span className="sourcing-row__fit-num">{fit}</span>
        </div>
      )}

      <p className="sourcing-row__loc">{location || ""}</p>
    </div>
  )
}

export default CandidateRow
